import React from 'react';
import { IFormatterProps } from '../../../@types/workspaceTypes';
import BooleanFormatter from './BooleanFormatter';
import { Tooltip } from '@fluentui/react-components';

const CheckFormatter = (props: IFormatterProps<any, boolean | `${boolean}`>) => {
  const { column, dependentValues, value, readOnly } = props;

  const content = !readOnly ? (
    <div className="checkboxIcon icon" title={column?.name}>
      {value ? 'check_box' : 'check_box_outline_blank'}
    </div>
  ) : (
    <BooleanFormatter {...props} />
  );

  if (dependentValues.options?.hint) {
    return (
      <Tooltip content={dependentValues.options?.hint} relationship={'label'}>
        {content}
      </Tooltip>
    );
  }

  return content;
};

export default CheckFormatter;
